import React from "react";

function Product() {
  return (
    <div>
      <h2>Products</h2>
      <p>Show all the products templates with their UPC numbers for quick adds.</p>
    </div>
  );
}

export default Product;
